import {
    confirmEmptyFolderAllSelectedItemsText,
    confirmEmptyFolderAllItemsText,
    confirmEmptyFolderAllUnreadItemsText,
    confirmEmptyFolderAllFlaggedItemsText,
    confirmEmptyFolderAllToMeItemsText,
    confirmEmptyFolderAllSelectedConversationsText,
    confirmEmptyFolderAllConversationsText,
    confirmEmptyFolderAllUnreadConversationsText,
    confirmEmptyFolderAllFlaggedConversationsText,
    confirmEmptyFolderAllToMeConversationsText,
} from '../../strings.locstring.json';
import ViewFilter from 'owa-service/lib/contract/ViewFilter';

export default function getItemsTypeTextForMoveToDeletedFolder(
    viewFilter: ViewFilter,
    isMessageView: boolean,
    isVirtualExclusion: boolean
): string {
    switch (viewFilter) {
        case 'Unread':
            return isMessageView
                ? confirmEmptyFolderAllUnreadItemsText
                : confirmEmptyFolderAllUnreadConversationsText;

        case 'Flagged':
            return isMessageView
                ? confirmEmptyFolderAllFlaggedItemsText
                : confirmEmptyFolderAllFlaggedConversationsText;

        case 'ToOrCcMe':
            return isMessageView
                ? confirmEmptyFolderAllToMeItemsText
                : confirmEmptyFolderAllToMeConversationsText;

        case 'All':
        default:
            return getTextForVirtualExclusionForMoveToDeletedFolder(
                isMessageView,
                isVirtualExclusion
            );
    }
}

// This function is responsible for determining the text for confirm dialog whether it is a message view
// or if it is virtual exclusion mode with a few items deselected.
function getTextForVirtualExclusionForMoveToDeletedFolder(
    isMessageView: boolean,
    isVirtualExclusion: boolean
): string {
    if (isMessageView) {
        // items view
        if (isVirtualExclusion) {
            return confirmEmptyFolderAllSelectedItemsText;
        } else {
            return confirmEmptyFolderAllItemsText;
        }
    } else {
        // conversations view
        if (isVirtualExclusion) {
            return confirmEmptyFolderAllSelectedConversationsText;
        } else {
            return confirmEmptyFolderAllConversationsText;
        }
    }
}
